<template>
  <div class="content">
    <div class="hospital hp_space_between" v-if="dept">
      <div class="hp_flex">
        <div class="hospitalImg hp_center">
          <img v-if="dept.image" :src="base_url+dept.image" alt />
          <img v-else src="@/assets/default-img/hospital.png" alt />
        </div>

        <div class="detail">
          <div class="tags hp_cz_center" style="margin-bottom: 0px;">
            <span class="name">{{ dept.name }}</span>
            <div v-if="dept.important" class="tag">{{ getImportantName(dept.important) }}</div>
          </div>
          <div class="tags hp_cz_center">
            <span class="hopital">{{ dept.hospitalName }}</span>
            <span v-if="dept.levelName" class="tag">{{ dept.levelName }}</span>
            <span v-if="dept.adminLevelName" class="tag">
              {{
              dept.adminLevelName
              }}
            </span>
            <template v-if="dept.typeNames">
              <div
                v-for="(tag, index) in dept.typeNames.split(',')"
                :key="index"
                class="tag"
              >{{ tag }}</div>
            </template>
          </div>
          <div class="mobile hp_cz_center">
            <icon-font style="font-size:14px;" type="icon-dianhua01" />
            <span>{{ dept.tel }}</span>
          </div>
          <p class="mobile hp_cz_center">
            <icon-font style="font-size:14px;" type="icon-dingwei2" />
            <span>{{ dept.address }}</span>
          </p>
        </div>
      </div>
    </div>
    <noData v-else></noData>
    <div class="brief">
      <h3>科室简介</h3>
      <div>{{dept.deptScope||'暂无简介'}}</div>
    </div>
  </div>
</template>
<script>
import {
  getDeptDetail,
  getScheduleDoctor,
  getReserveDoctor,
} from "@/api/registered";
import noData from "@/components/NoData";
export default {
  components: {
    noData,
  },
  data() {
    return {
      deptId: this.$route.params.id,
      dept: {},
      timeDaysList: [],
      doctorDay: [],
      doctorAll: [],
      loading1: true,
      loading2: true,
      active: 0,
    };
  },
  created() {
    this.initDept();
    this.$store.commit("showLoading");
  },
  mounted() {},
  methods: {
    async initDept() {
      this.$store.commit("showLoading");
      var res = await getDeptDetail(this.deptId);
      this.dept = res.data;
      this.$store.commit("hideLoading");
      this.$route.meta.name = this.dept.name;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 911px;
  box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
  border-radius: 10px;
  padding: 25px 21px;
  .hospital {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    position: relative;
    .hospitalImg {
      width: 339px;
      height: 220px;
      margin-right: 26px;
      border-radius: 6px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    .detail {
      width: calc(100% - 420px);
      .tags {
        width: 100%;
        flex-wrap: wrap;
        margin-top: 6px;
        margin-bottom: 15px;
        .name {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-right: 10px;
        }
        .hopital {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          margin-right: 18px;
          margin-bottom: 12px;
        }
        .tag {
          border-radius: 10px;
          padding: 7px 12px;
          line-height: 1;
          font-size: 14px;
          color: #ffffff;
          background: #0079fe;
        }
        .tag:not(:last-child) {
          margin-right: 19px;
        }
      }
      .mobile {
        width: 100%;
        margin-top: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        span {
          margin-left: 15px;
        }
      }
    }
  }
  .brief {
    margin-top: 20px;
    font-size: 18px;
    > h3 {
      font-size: 30px;
      font-weight: 800;
      margin-bottom: 20px;
    }
  }
}
</style>
